import classNames from 'classnames';

import { SEMANTIC_COLOR } from '@/shared/design-tokens/design-tokens';
import { Icon } from '@/shared/ui/Icon';

import { useConnectors } from '@/entities/connector';

import styles from './ConnectorDashboard.module.css';

export const ConnectorDashboard = () => {
  const { data } = useConnectors();

  const summary = data?.summary;
  const enableCount = summary?.enable ?? 0;
  const disableCount = summary?.disable ?? 0;
  const failureCount = summary?.failure ?? 0;
  const totalCount = enableCount + disableCount;

  return (
    <div className={styles.dashboard}>
      <div className={styles.total}>
        <span className={styles.totalLabel}>Total</span>
        <span className={styles.totalValue}>{totalCount.toLocaleString()}</span>
      </div>
      <div className={styles.whiteSpace}>
        <div className={styles.whiteSpaceItem}>
          <div className={classNames(styles.whiteSpaceItemIcon, styles.purple)}>
            <Icon name="light-on" width={32} height={32} color={SEMANTIC_COLOR.ON_CONTAINER.COLORFUL.PURPLE} />
          </div>
          <div className={styles.whiteSpaceItemContent}>
            <span className={styles.whiteSpaceLabel}>Activation Connector</span>
            <span className={styles.whiteSpaceValue}>{enableCount.toLocaleString()}</span>
          </div>
        </div>
        <div className={styles.border} />
        <div className={styles.whiteSpaceItem}>
          <div className={classNames(styles.whiteSpaceItemIcon, styles.red)}>
            <Icon name="cancel" width={32} height={32} color={SEMANTIC_COLOR.ON_CONTAINER.COLORFUL.RED} />
          </div>
          <div className={styles.whiteSpaceItemContent}>
            <span className={styles.whiteSpaceLabel}>Connecting failure</span>
            <span className={styles.whiteSpaceValue}>{failureCount.toLocaleString()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
